module.exports = new __parcel__URL__("A2.4320620e.mp3").toString();